import React from 'react';
import './Spinner.css'; // Make sure this CSS file exists

const Spinner = () => (
    <div className="spinner-overlay">
        <div className="spinner-container"></div>
    </div>
);

export default Spinner;
